

// import React, { useEffect, useState } from 'react';
// import { useParams, useNavigate } from 'react-router-dom';
// import axios from 'axios';
// import DashSide from '../components/DashSide';

// const MessageDetailPage = () => {
//   const { id } = useParams();
//   const [msg, setMsg] = useState(null);
//   const [activePage, setActivePage] = useState('users');
//   const navigate = useNavigate();

//   useEffect(() => {
//     axios.get(`http://localhost:8080/api/v1/admin/messages/${id}`, { withCredentials: true })
//       .then(res => setMsg(res.data))
//       .catch(err => console.error(err));
//   }, [id]);

//   const handleNavigate = (page) => {
//     setActivePage(page);
//     if (page === 'dashboard') navigate('/admin-dashboard');
//     if (page === 'users') navigate('/admin-dashboard'); // or another users route
//     if (page === 'messages') navigate('/admin-dashboard'); // or messages route
//   };

//   if (!msg) return <div className="p-8">Loading message...</div>;

//   return (
//     <div className="flex w-screen min-h-screen bg-gray-100">
//       <DashSide onNavigate={handleNavigate} activePage={activePage} />
//       <div className="p-8 bg-gray-100 flex-1 overflow-y-auto">
//         <h2 className="text-2xl font-bold mb-4">Message Details</h2>
//         <div className="bg-white p-6 rounded-xl shadow space-y-4">
//           <p><strong>SenderId</strong>{msg.senderId}</p>
//           <p><strong>SenderName:</strong> {msg.senderName}</p>
//           <p><strong>Message:</strong>{msg.message}</p>
//           <p><strong>Status:</strong>{msg.status}</p>
//           <p><strong>CreatedAt:</strong></p>{msg.createdAt}
        
//         </div>
//       </div>
//     </div>
//   );
// };

// export default MessageDetailPage;


import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import axios from 'axios';
import DashSide from '../components/DashSide';

const MessageDetailPage = () => {
  const { id } = useParams();
  const [msg, setMsg] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [activePage, setActivePage] = useState('messages');
  const navigate = useNavigate();

  useEffect(() => {
    const fetchMessage = async () => {
      try {
        const res = await axios.get(`/api/v1/admin/messages/${id}`, { 
          withCredentials: true 
        });
        setMsg(res.data);
      } catch (err) {
        console.error('Error fetching message:', err);
        setError(err.response?.data?.error || 'Failed to load message');
      } finally {
        setLoading(false);
      }
    };
    
    fetchMessage();
  }, [id]);

  const handleNavigate = (page) => {
    setActivePage(page);
    if (page === 'dashboard') navigate('/admin-dashboard');
    if (page === 'users') navigate('/admin-dashboard');
    if (page === 'messages') navigate('/admin-dashboard');
  };

  if (loading) return <div className="p-8">Loading message...</div>;
  if (error) return <div className="p-8 text-red-500">Error: {error}</div>;
  if (!msg) return <div className="p-8">Message not found</div>;

  return (
    <div className="flex w-screen min-h-screen bg-gray-100">
      <DashSide onNavigate={handleNavigate} activePage={activePage} />
      <div className="p-8 bg-gray-100 flex-1 overflow-y-auto">
        <h2 className="text-2xl font-bold mb-4">Message Details</h2>
        <div className="bg-white p-6 rounded-xl shadow space-y-4">
          <p><strong>Sender ID:</strong> {msg.senderId}</p>
          <p><strong>Sender Name:</strong> {msg.senderName}</p>
          <p><strong>Message:</strong> {msg.message}</p>
          <p><strong>Status:</strong> {msg.status}</p>
          <p><strong>Created At:</strong> {new Date(msg.createdAt).toLocaleDateString('en-GB', {
            day: '2-digit',
            month: 'short',
            year: 'numeric'
          }).replace(/ /g, '-')}</p>
        </div>
      </div>
    </div>
  );
};

export default MessageDetailPage;